import React from 'react';
import styled from 'styled-components';
import backgroundImg from 'assets/images/backgroundx2.png';

import LoginContainer from '../components/Login';

export const ScreenWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-width: 600px;
  height: 100vh;
  min-height: 720px;
  padding: 20px;
  background: url(${backgroundImg});
  background-size: 100% 100%;
  box-sizing: border-box;

  @media screen and (max-width: 768px) {
    min-width: unset;
  }
`;

const LoginScreen = () => (
  <ScreenWrapper>
    <LoginContainer />
  </ScreenWrapper>
);
export default LoginScreen;
